module.exports = __webpack_public_path__ + "static/img/map_3.3351a42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/search/map_3.png
// module id = 0FPZ
// module chunks = 1